import { render, staticRenderFns } from "./EngApvsIndex.vue?vue&type=template&id=b85677de&scoped=true&"
import script from "./EngApvsIndex.vue?vue&type=script&lang=js&"
export * from "./EngApvsIndex.vue?vue&type=script&lang=js&"
import style0 from "./EngApvsIndex.vue?vue&type=style&index=0&id=b85677de&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85677de",
  null
  
)

export default component.exports